// import React, { useEffect, useState } from "react";
// import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
// import NoData from "../../NoData";
// import ChartLoader from '../../ChartLoader';
// import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
// import WaterMark from "../../DashboardMain_Orion/WaterMark";
// import { BsZoomIn } from "react-icons/bs";
// import { Bar } from "react-chartjs-2";
// import CommanBarTable_Orion from "../CommanBarTable_Orion";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   scales
// } from "chart.js";
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );
// let Maxchartdata
// let res_result

// function MaxCellTemp_cycles_Orion({ apiend, gloablfilter, type, maxCellTemp_Option, chartnameFCD }) {
//   const [chartdata, setChartData] = useState([]);
//   const { isLoading, error, sendReq: fetchData } = useHttp();
//   const [chartname, SetChartName] = useState(chartnameFCD);
//   let barcolor
//   let toPush = [];
//   let toPushfast = [];
//   const appyDataCycles = (data) => {
//     res_result = data;
//     toPush = [];
//     let responce = {
//       "<=20": 0,
//       "22": 0,
//       "24": 0,
//       "26": 0,
//       "28": 0,
//       "30": 0,
//       "32": 0,
//       "34": 0,
//       "36": 0,
//       "38": 0,
//       "40": 0,
//       "42": 0,
//       "44": 0,
//       ">44": 0,
//     }

//     if (res_result.length !== 0) {
//       let d = res_result[0];

//       if (d.B1.value)
//         responce["<=20"] = d.B1.value
//       if (d.B2.value)
//         responce["22"] = d.B2.value
//       if (d.B3.value)
//         responce["24"] = d.B3.value
//       if (d.B4.value)
//         responce["26"] = d.B4.value
//       if (d.B5.value)
//         responce["28"] = d.B5.value
//       if (d.B6.value)
//         responce["30"] = d.B6.value
//       if (d.B7.value)
//         responce["32"] = d.B7.value
//       if (d.B8.value)
//         responce["34"] = d.B8.value
//       if (d.B9.value)
//         responce["36"] = d.B9.value
//       if (d.B10.value)
//         responce["38"] = d.B10.value
//       if (d.B11.value)
//         responce["40"] = d.B11.value
//       if (d.B12.value)
//         responce["42"] = d.B12.value
//       if (d.B13.value)
//         responce["44"] = d.B13.value
//       if (d.B14.value)
//         responce[">44"] = d.B14.value

//       toPush.push(d.B1.value)
//       toPush.push(d.B2.value)
//       toPush.push(d.B3.value)
//       toPush.push(d.B4.value)
//       toPush.push(d.B5.value)
//       toPush.push(d.B6.value)
//       toPush.push(d.B7.value)
//       toPush.push(d.B8.value)
//       toPush.push(d.B9.value)
//       toPush.push(d.B10.value)
//       toPush.push(d.B11.value)
//       toPush.push(d.B12.value)
//       toPush.push(d.B13.value)
//       toPush.push(d.B14.value)

//       let res_result_final = [["Element", "Count", { role: "style" }]]
//       let loop_keys = Object.keys(responce);

//       loop_keys = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
//       let countcheck = 0
//       for (const key in responce) {
//         if (responce[key] > 0) {
//           countcheck = countcheck + 1
//         }
//       }
//       loop_keys.map(x => {
//         if (countcheck)
//           // barcolor
//           res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
//       })

//       const labels = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
//       Maxchartdata = {
//         labels,
//         datasets: [
//           {
//             label: "deg Celcius",
//             data: responce,
//             backgroundColor: barcolor,
//             borderWidth: 1,
//             borderColor: "black",
//           },
//         ]
//       };
//       setChartData((prestate) => res_result_final);
//     } else {
//       setChartData((prestate) => []);
//     }
//   }

//   const options1 = {
//     responsive: true,
//     categoryPercentage: 1.0,
//     barPercentage: 1.0,
//     scales: {
//       x: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'deg Celcius'
//         },
//         suggestedMin: 0,
//         ticks: {
//           autoSkip: false,
//           maxRotation: 0,
//           minRotation: 0,
//         }
//       },

//       y: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'Charging Cycles'
//         },
//         suggestedMin: 0,
//       },
//     },

//     plugins: {
//       legend: {
//         display: false
//       },
//     }
//   }

//   const options = {
//     hAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'deg Celcius',
//       minValue: 0,
//       format: 'short',
//       direction: 1,
//       slantedText: true,
//       slantedTextAngle: 90
//     },

//     vAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'Charging Cycles',
//       minValue: 0,
//       format: 'short',

//     },
//     bar: { groupWidth: "100%" },
//     legend: "none",
//     isStacked: false,
//     series: {
//       0: { color: "#3578b0" },
//     },
//   };

//   const [tempMaxTemp, setTempMaxTemp] = useState("")
//   useEffect(() => {
//     setTempMaxTemp(maxCellTemp_Option)
//     settoPushPopUp([])
//     fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter, maxCellTemp_Option: maxCellTemp_Option } }, appyDataCycles)
//     barcolor = "#3578b0"
//     SetChartName(chartnameFCD);
//   }, [gloablfilter, type, maxCellTemp_Option])

//   const [toPushPopUp, settoPushPopUp] = useState([]);
//   const appyDataClick = (data) => {
//     let toPushPopUpArr = []
//     let hits = data;

//     hits.map((i, key) => {
//       toPushPopUpArr.push({
//         "key": {
//           "vehicleId": i.key.vehicleId,
//           "Depot_Name": i.key.Depot_Name,
//           "DLR_ORG_CITY": i.key.DLR_ORG_CITY,
//           "vehicle_registration_number": i.key.vehicle_registration_number
//         },
//         "doc_count": 9,
//         [tempMaxTemp]: {
//           "values": {
//             "50.0": i.doc_count
//           }
//         }
//       })
//     })
//     toPushPopUpArr.sort((a, b) => b[tempMaxTemp].values["50.0"] - a[tempMaxTemp].values["50.0"]);
//     settoPushPopUp(toPushPopUpArr)
//   }

//   return (
//     <>
//       <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
//               {
//                 (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
//                   : <NoData />
//                 )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

//       <WaterMark />

//       {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
//         {
//           eventName: "select",
//           callback({ chartWrapper }) {
//             const chart = chartWrapper.getChart()
//             const selection = chart.getSelection()
//             const [selectedItem] = selection;
//             const { row } = selectedItem;
//             const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

//             let from_bucket;
//             let to_bucket;
//             const count = chartWrapper.getDataTable().Wf[row].c[1].v;
//             if (count !== 0) {
//               if (barvalue === "<=20") {
//                 from_bucket = 0
//                 to_bucket = 20
//               } else if (barvalue === ">44") {
//                 from_bucket = 44
//                 to_bucket = null
//               } else {
//                 from_bucket = barvalue - 2
//                 to_bucket = barvalue
//               }

//               fetchData({ url: API_URL_MAIN + "orion_charging_analysis/max_cell_temp_cycles_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket), maxCellTemp_Option: tempMaxTemp } }, appyDataClick)
//               window.$('#exampleModal__' + apiend).modal('show');
//             }
//           }
//         }
//       ]}
//       /> : <NoData />)}

//       <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
//             <div className="modal-body">
//               {/* <table className="table table-striped">
//                 <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
//                   <tr>
//                     <th scope="col">Vin Number</th>
//                     <th scope="col">Cycles Count</th>
//                   </tr></thead>
//                 <tbody> */}
//               <CommanBarTable_Orion data={toPushPopUp} tabDataKey={tempMaxTemp} />
//               {/* </tbody></table> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default MaxCellTemp_cycles_Orion;

import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import CommanBarTable_Orion from "../CommanBarTable_Orion";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result

function MaxCellTemp_cycles_Orion({ apiend, gloablfilter, type, maxCellTemp_Option, chartnameFCD }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor
  let toPush = [];
  let toPushfast = [];
  // const appyDataCycles = (data) => {
  //   res_result = data;
  //   toPush = [];

  //   // NEW: bins of size 4 (aggregated from original B1..B14)
  //   let responce = {
  //     "<=20": 0,
  //     "20-24": 0,
  //     "24-28": 0,
  //     "28-32": 0,
  //     "32-36": 0,
  //     "36-40": 0,
  //     "40-44": 0,
  //     ">44": 0,
  //   }

  //   if (res_result.length !== 0) {
  //     let d = res_result[0];

  //     // Map and aggregate original B1..B14 into new bins
  //     // Original mapping (B1..B14): <=20, 22,24,26,28,30,32,34,36,38,40,42,44,>44
  //     // New bins: <=20, 20-24 (B2+B3), 24-28 (B4+B5), 28-32 (B6+B7), 32-36 (B8+B9), 36-40 (B10+B11), 40-44 (B12+B13), >44 (B14)

  //     if (d.B1 && d.B1.value) {
  //       responce["<=20"] = d.B1.value;
  //     }
  //     // 20-24 => B2 + B3
  //     responce["20-24"] = ((d.B2 && d.B2.value) ? d.B2.value : 0) + ((d.B3 && d.B3.value) ? d.B3.value : 0);
  //     // 24-28 => B4 + B5
  //     responce["24-28"] = ((d.B4 && d.B4.value) ? d.B4.value : 0) + ((d.B5 && d.B5.value) ? d.B5.value : 0);
  //     // 28-32 => B6 + B7
  //     responce["28-32"] = ((d.B6 && d.B6.value) ? d.B6.value : 0) + ((d.B7 && d.B7.value) ? d.B7.value : 0);
  //     // 32-36 => B8 + B9
  //     responce["32-36"] = ((d.B8 && d.B8.value) ? d.B8.value : 0) + ((d.B9 && d.B9.value) ? d.B9.value : 0);
  //     // 36-40 => B10 + B11
  //     responce["36-40"] = ((d.B10 && d.B10.value) ? d.B10.value : 0) + ((d.B11 && d.B11.value) ? d.B11.value : 0);
  //     // 40-44 => B12 + B13
  //     responce["40-44"] = ((d.B12 && d.B12.value) ? d.B12.value : 0) + ((d.B13 && d.B13.value) ? d.B13.value : 0);
  //     // >44 => B14
  //     responce[">44"] = (d.B14 && d.B14.value) ? d.B14.value : 0;

  //     // Build toPush in the same order as labels
  //     toPush.push(responce["<=20"]);
  //     toPush.push(responce["20-24"]);
  //     toPush.push(responce["24-28"]);
  //     toPush.push(responce["28-32"]);
  //     toPush.push(responce["32-36"]);
  //     toPush.push(responce["36-40"]);
  //     toPush.push(responce["40-44"]);
  //     toPush.push(responce[">44"]);

  //     let res_result_final = [["Element", "Count", { role: "style" }]]
  //     // NEW loop keys for aggregated bins
  //     let loop_keys = ["<=20", "20-24", "24-28", "28-32", "32-36", "36-40", "40-44", ">44"]
  //     let countcheck = 0
  //     for (const key in responce) {
  //       if (responce[key] > 0) {
  //         countcheck = countcheck + 1
  //       }
  //     }
  //     loop_keys.map(x => {
  //       if (countcheck)
  //         // barcolor
  //         res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
  //     })

  //     const labels = ["<=20", "20-24", "24-28", "28-32", "32-36", "36-40", "40-44", ">44"]
  //     Maxchartdata = {
  //       labels,
  //       datasets: [
  //         {
  //           label: "deg Celcius",
  //           // For ChartJS dataset we pass an array of numbers (toPush),
  //           // for consistency with previous approach keep using 'responce' where appropriate.
  //           data: toPush,
  //           backgroundColor: barcolor,
  //           borderWidth: 1,
  //           borderColor: "black",
  //         },
  //       ]
  //     };
  //     setChartData((prestate) => res_result_final);
  //   } else {
  //     setChartData((prestate) => []);
  //   }
  // }
  const appyDataCycles = (data) => {
  res_result = data;
  toPush = [];

  let responce = {
    "<20": 0,
    "20-24": 0,
    "24-28": 0,
    "28-32": 0,
    "32-36": 0,
    "36-40": 0,
    "40-44": 0,
    ">44": 0,
  };

  if (res_result.length !== 0) {
    let d = res_result[0];

    if (d.B1?.value) responce["<20"]   = d.B1.value;
    if (d.B2?.value) responce["20-24"] = d.B2.value;
    if (d.B3?.value) responce["24-28"] = d.B3.value;
    if (d.B4?.value) responce["28-32"] = d.B4.value;
    if (d.B5?.value) responce["32-36"] = d.B5.value;
    if (d.B6?.value) responce["36-40"] = d.B6.value;
    if (d.B7?.value) responce["40-44"] = d.B7.value;
    if (d.B8?.value) responce[">44"]   = d.B8.value;

    toPush.push(
      d.B1?.value,
      d.B2?.value,
      d.B3?.value,
      d.B4?.value,
      d.B5?.value,
      d.B6?.value,
      d.B7?.value,
      d.B8?.value
    );

    let res_result_final = [["Element", "Count", { role: "style" }]];

    let loop_keys = [
      "<20",
      "20-24",
      "24-28",
      "28-32",
      "32-36",
      "36-40",
      "40-44",
      ">44",
    ];

    let countcheck = 0;
    for (const key in responce) {
      if (responce[key] > 0) {
        countcheck = countcheck + 1;
      }
    }

    loop_keys.map((x) => {
      if (countcheck)
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;",
        ]);
    });

    const labels = loop_keys;

    Maxchartdata = {
      labels,
      datasets: [
        {
          label: "deg Celcius",
          data: toPush,
          backgroundColor: barcolor,
          borderWidth: 1,
          borderColor: "black",
        },
      ],
    };

    setChartData(res_result_final);
  } else {
    setChartData([]);
  }
};


  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'deg Celcius'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'deg Celcius',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',

    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#3578b0" },
    },
  };

  const [tempMaxTemp, setTempMaxTemp] = useState("")
  useEffect(() => {
    setTempMaxTemp(maxCellTemp_Option)
    settoPushPopUp([])
    fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter, maxCellTemp_Option: maxCellTemp_Option } }, appyDataCycles)
    barcolor = "#3578b0"
    SetChartName(chartnameFCD);
  }, [gloablfilter, type, maxCellTemp_Option])

  const [toPushPopUp, settoPushPopUp] = useState([]);
  const appyDataClick = (data) => {
    let toPushPopUpArr = []
    let hits = data;

    hits.map((i, key) => {
      toPushPopUpArr.push({
        "key": {
          "vehicleId": i.key.vehicleId,
          "Depot_Name": i.key.Depot_Name,
          "DLR_ORG_CITY": i.key.DLR_ORG_CITY,
          "vehicle_registration_number": i.key.vehicle_registration_number
        },
        "doc_count": 9,
        [tempMaxTemp]: {
          "values": {
            "50.0": i.doc_count
          }
        }
      })
    })
    toPushPopUpArr.sort((a, b) => b[tempMaxTemp].values["50.0"] - a[tempMaxTemp].values["50.0"]);
    settoPushPopUp(toPushPopUpArr)
  }

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: "select",
          callback({ chartWrapper }) {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            const [selectedItem] = selection;
            const { row } = selectedItem;
            const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

            let from_bucket;
            let to_bucket;
            const count = chartWrapper.getDataTable().Wf[row].c[1].v;
            if (count !== 0) {
              // NEW: barvalue is label string (e.g. "<=20", "20-24", "24-28", ..., ">44")
              if (barvalue === "<=20") {
                from_bucket = 0
                to_bucket = 20
              } else if (barvalue === ">44") {
                from_bucket = 44
                to_bucket = null
              } else {
                // parse labels like "20-24" into numeric bounds
                const parts = String(barvalue).split('-');
                if (parts.length === 2) {
                  from_bucket = parseInt(parts[0], 10);
                  to_bucket = parseInt(parts[1], 10);
                } else {
                  // fallback: try numeric value (defensive)
                  const numeric = parseInt(barvalue, 10);
                  from_bucket = numeric - 2;
                  to_bucket = numeric;
                }
              }

              fetchData({ url: API_URL_MAIN + "orion_charging_analysis/max_cell_temp_cycles_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: (to_bucket === null ? null : parseInt(to_bucket)), maxCellTemp_Option: tempMaxTemp } }, appyDataClick)
              window.$('#exampleModal__' + apiend).modal('show');
            }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
            <div className="modal-body">
              {/* <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">Cycles Count</th>
                  </tr></thead>
                <tbody> */}
              <CommanBarTable_Orion data={toPushPopUp} tabDataKey={tempMaxTemp} />
              {/* </tbody></table> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaxCellTemp_cycles_Orion;
